var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirstAid = function SvgFirstAid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "first-aid_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.801 5v16.2H59v21.6H42.8V59H21.2V42.801H5V21.199h16.2V5zM25.2 25.2H9v13.6h16.2V55H38.8V38.801H55V25.199H38.8V9H25.2z"
  })));
};
export { SvgFirstAid as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNDIuODAxNCA1VjIxLjE5OTJINTguOTk5NlY0Mi44MDA4SDQyLjgwMTRWNTguOTk5SDIxLjE5OThWNDIuODAwOEg1LjAwMDYxVjIxLjE5OTJIMjEuMTk5OFY1SDQyLjgwMTRaTTI1LjE5OTggMjUuMTk5Mkg5LjAwMDYxVjM4LjgwMDhIMjUuMTk5OFY1NC45OTlIMzguODAxNFYzOC44MDA4SDU0Ljk5OTZWMjUuMTk5MkgzOC44MDE0VjlIMjUuMTk5OFYyNS4xOTkyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";